<template>
  <AppRow
    v-if="visible"
    align="center"
  >
    <AppColumn
      class="py-0"
      :cols="cols || 8"
    >
      <span v-if="def.inputType">
        <span v-if="def.lookup">
          <AppAutoComplete
            v-if="def.inputType.name === 'ECore.Def.DefEnums.itAutoComplete'"
            v-bind="$attrs"
            v-model="model.value"
            dense
            :def="def"
            :items="LookupItems"
            item-text="DisplayText"
            item-value="ID"
            hide-no-data
            :error-messages="errorMessages"
            @keyup="inputLookup"
          ></AppAutoComplete>
          <AppRiskIdSelector
            v-if="def.inputType.name === 'ECore.Def.DefEnums.itRiskIdSelector'"
            v-bind="$attrs"
            v-model="model.value"
            dense
            :def="def"
            :items="LookupItems"
            item-text="DisplayText"
            item-value="ID"
            hide-no-data
            :error-messages="errorMessages"
            @keyup="inputLookup"
          ></AppRiskIdSelector>
          <AppSelectBox
            v-if="def.inputType.name === 'ECore.Def.DefEnums.itSelect' || def.inputType.name === 'ECore.Def.DefEnums.itMultiSelect'"
            v-bind="$attrs"
            v-model="model.value"
            dense
            :def="def"
            :items="LookupItems"
            item-text="DisplayText"
            item-value="ID"
            :multiple="def.inputType.name === 'ECore.Def.DefEnums.itMultiSelect'"
            :error-messages="errorMessages"
          ></AppSelectBox>
        </span>
        <span v-else>
          <span v-if="def.inputType.name === 'ECore.Def.DefEnums.itText'">
            <AppTextField
              v-bind="$attrs"
              v-model.trim="model.value"
              :error-messages="errorMessages"
              :def="def"
            ></AppTextField>
          </span>
          <span v-else-if="def.inputType.name === 'ECore.Def.DefEnums.itSelect'">
            <AppSelectBox
              v-model="model.value"
              :error-messages="errorMessages"
              :def="def"
            ></AppSelectBox>
          </span>
          <span
            v-else-if="def.inputType.name === 'ECore.Def.DefEnums.itMultiSelect'"
          >
            <AppSelectBox
              v-model="model.value"
              :error-messages="errorMessages"
              :def="def"
              is-multiple="true"
            ></AppSelectBox>
          </span>
          <span
            v-else-if="def.inputType.name === 'ECore.Def.DefEnums.itAutoComplete'"
          >
            <AppAutoComplete
              v-model="model.value"
              :error-messages="errorMessages"
              :def="def"
            ></AppAutoComplete>
          </span>
          <span
            v-else-if="def.inputType.name === 'ECore.Def.DefEnums.itCheckBox'"
          >
            <AppCheckBox
              v-model="model.value"
              :def="def"
            ></AppCheckBox>
          </span>
          <span v-else-if="def.inputType.name === 'ECore.Def.DefEnums.itSwitch'">
            <AppSwitch
              v-model="model.value"
              :def="def"
              :error-messages="errorMessages"
            ></AppSwitch>
          </span>
          <span v-else-if="def.inputType.name === 'ECore.Def.DefEnums.itRiskIdSelector'">
            <AppRiskIdSelector
              v-model="model.value"
              :def="def"
              :error-messages="errorMessages"
            ></AppRiskIdSelector>
          </span>
          <span
            v-else-if="def.inputType.name === 'ECore.Def.DefEnums.itLocalDate'"
          >
            <AppDatePicker
              :locale="locale"
              :def="{ ...def, name: 'value' }"
              :model="model"
              :error-messages="errorMessages"
            ></AppDatePicker>
          </span>
          <span
            v-else-if="def.inputType.name === 'ECore.Def.DefEnums.itDateAndTime'"
          >
            <AppDateAndTimePicker
              :locale="locale"
              :def="{ ...def, name: 'value' }"
              :model="model"
              :error-messages="errorMessages"
            ></AppDateAndTimePicker>
          </span>
          <span
            v-else-if="def.inputType.name === 'ECore.Def.DefEnums.itGlobalDate'"
          >
            <AppDatePicker
              locale="en"
              :def="{ ...def, name: 'value' }"
              :model="model"
              :error-messages="errorMessages"
            ></AppDatePicker>
          </span>
        </span>
      </span>
      <span v-else>
        <AppTextField
          v-model.trim="model.value"
          :error-messages="errorMessages"
          :def="def"
        ></AppTextField>
      </span>
    </AppColumn>
    <AppColumn
      v-if="def.conditions && $parent?.def?.id !== 'LA.LifeCmn.FrmReport.pgReport'" 
      cols="4"
      style="padding: 2px!important; "
    >
      <AbrAdvancedSearchCondition
        v-model="model.condition"
        :def="def.conditions"
      ></AbrAdvancedSearchCondition>
    </AppColumn>
  </AppRow>
</template>

<script>
import AppRow from "@/components/library/container/AppRow";
import AppColumn from "@/components/library/container/AppColumn";
import AbrAdvancedSearchCondition from "@/components/search/AbrAdvancedSearchCondition";
import AppTextField from "@/components/library/inputFields/AppTextField";
import AppSelectBox from "@/components/library/inputFields/AppSelectBox";
import AppAutoComplete from "@/components/library/inputFields/AppAutoComplete";
import AppCheckBox from "@/components/library/inputFields/AppCheckBox";
import AppSwitch from "@/components/library/inputFields/AppSwitch";
import AppDatePicker from "../library/inputFields/AppDatePicker";
import AbrValidate from "../../mixins/AbrValidate";
import AppRiskIdSelector from "../library/inputFields/AppRiskIdSelector.vue";
import AppDateAndTimePicker from "../library/inputFields/AppDateAndTimePicker.vue";
import AbrEventsOff from "@/mixins/AbrEventsOff";

export default {
  components: {
    AppDatePicker,
    AppSwitch,
    AppCheckBox,
    AppAutoComplete,
    AppSelectBox,
    AppTextField,
    AppColumn,
    AppRow,
    AbrAdvancedSearchCondition,
    AppRiskIdSelector,
    AppDateAndTimePicker
  },
  mixins: [AbrValidate, AbrEventsOff],
  props: ["def", "model", "queryModel", "cols"], //model is search field { condition, value }
  data: () => ({
    lookupItems: [],
    events: {},
    visible: true,
    validations: [],
    errorMessages: [],
    valid: true,
    cascadeProp: undefined,
    //get locale data from stare state
    locale: null
  }),
  computed: {
    LookupItems() {
      let items = this.lookupItems;
      // console.log('LookupItems (',this.def.name,') :: this.cascadeProp :>> ', this.cascadeProp);
      // console.log('LookupItems (',this.def.name,') :: items :>> ', items);
      if (this.cascadeProp)
        items = items?.filter(
            (i) =>{
              // console.log('LookupItems (',this.def.name,') :: i.CascadeValue :>> ', i.CascadeValue);
              // console.log('LookupItems (',this.def.name,') :: this.queryModel[this.cascadeProp]?.value :>> ', this.queryModel[this.cascadeProp]?.value);
              return (!this.cascadeProp ||
                i.CascadeValue === this.queryModel[this.cascadeProp]?.value ||
                !i.CascadeValue)}
        );
      // console.log('LookupItems (',this.def.name,') :: items :>> ', items);
      return items;
    },
  },
  async created() {
    this.locale = this.$store.state.locale === 'fa-IR' ? 'fa' : 'en';
    this.cascadeProp = this.def?.lookupCascade?.name?.split(".").pop();
    this.visible = await this.$checkVisibility(this.def);
    if(this.def.eventHandlers)
      this.events = this.$processEvent(this.def.eventHandlers, this.def.id, this);
    this.$nextTick(() => {
      this.$eventBus.$emit(`${this.def.id}-onLoad`);
    })
    if (this.def.lookup) {
      await this.fetchLookupItems();
    }
    this.validations = this.def.validations?.filter(v => v.fn);
    this.$watch("model.value", this.validate, { deep: true });
    this.$eventBus.$emit("addSearchProp", this);
},
  methods: {
    async fetchLookupItems(query) {
      // this.lookupItems = await this.$abr.api.fetchLookupData(this.def.lookup, undefined, query);
      // console.log('fetchLookupItems (',this.def.name,') :: this.lookupItems :>> ', this.lookupItems);

      const data = await this.$abr.api.fetchLookupData(
        this.def.lookup,
        this.filterValue || undefined,
        query
      )
      //console.log('AbrSearchProp :: fetchLookupItems (',this.def.name,') :: data :>> ', data);

      this.lookupItems = [...data];

      // console.log('AbrSearchProp :: fetchLookupItems (',this.def.name,') :: this.lookupItems :>> ', this.lookupItems);
      // console.log('AbrSearchProp :: fetchLookupItems (',this.def.name,') :: this.def.lookupSettingExpr :>> ', this.def.lookupSettingExpr);
      
      if (this.def.lookupSettingExpr) {
        await this.$eval(this.def.lookupSettingExpr);
        return;
      }
      const routeQuery = this.$route.query;
      const product = routeQuery?.ProductDefID;      
      
      // console.log('AbrSearchProp ::  fetchLookupItems (', this.def.name ,') :: product :>> ', product);
      if (product && !this.$store.state.products[product]) {
        // console.log('AbrSearchProp ::  fetchLookupItems (', this.def.name ,') :: getproduct()');
          await this.$getProduct(product);
          this.productLoaded = true;
        }

      const getProductInfo = this.$getProductInfo();
      // console.log('AbrSearchProp ::  fetchLookupItems (', this.def.name ,') :: getProductInfo :>> ', getProductInfo);
      
      const currentSetting = getProductInfo
        ?.setting?.sections?.find((s) => s.name === "ControlParams")
        .params.flatMap((cs) => cs.nestedParams || cs);            
      // console.log('AbrSearchProp ::  fetchLookupItems (', this.def.name ,') :: currentSetting :>> ', currentSetting);
      // console.log('AbrSearchProp ::  fetchLookupItems (', this.def.name ,') :: this.def.lookup.name :>> ', this.def.lookup.name);

      if (!currentSetting) return;
      currentSetting.forEach((param) => {
        if (
          param.lookup &&
          param.value?.json &&
          this.def.lookup.name === param.lookup.name
        )
          {
            // console.log('AbrSearchProp ::  fetchLookupItems (', this.def.name ,') :: param.lookup :>> ', param.lookup);
            // console.log('AbrSearchProp ::  fetchLookupItems (', this.def.name ,') :: param.value :>> ', param.value);
            // console.log('AbrSearchProp ::  fetchLookupItems (', this.def.name ,') :: param.lookup.name :>> ', param.lookup.name);
            this.lookupItems = this.lookupItems.filter((val) =>
            JSON.parse(param.value?.json).includes(val.ID)
          );
        }
      });
      // console.log('AbrSearchProp ::  fetchLookupItems (', this.def.name ,') :: this.lookupItems :>> ', this.lookupItems);

    },
    // ######################
    inputLookup() {
      const value = event.target.value;
      this.fetchLookupItems(value);
    },

  }
};
</script>
